/* ============================================================
   Login / Register / Recover — mock flow
   ============================================================ */

import React, { useState } from 'react';
import { Wordmark, Icon } from '../components/shared.jsx';

function GoogleIcon({ size = 18 }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24">
      <path fill="#4285F4" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"/>
      <path fill="#34A853" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"/>
      <path fill="#FBBC05" d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z"/>
      <path fill="#EA4335" d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z"/>
    </svg>
  );
}

function AuthShell({ children, eyebrow, title, subtitle }) {
  return (
    <div className="r-auth-grid">
      {/* Left form */}
      <div className="r-auth-form" style={{ display: 'flex', flexDirection: 'column', padding: '40px 64px' }}>
        <div style={{ marginBottom: 'auto' }}>
          <Wordmark height={28}/>
        </div>
        <div style={{ maxWidth: 400, width: '100%', margin: '0 auto', flex: 1, display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
          <div className="eyebrow" style={{ marginBottom: 12 }}>{eyebrow}</div>
          <h1 className="h-2" style={{ marginBottom: 8 }}>{title}</h1>
          {subtitle && <p className="secondary" style={{ fontSize: 15, lineHeight: 1.5, marginBottom: 32 }}>{subtitle}</p>}
          {children}
        </div>
        <div className="flex items-center justify-between text-mono" style={{ fontSize: 12, color: 'var(--fg-muted)', marginTop: 'auto' }}>
          <span>© 2026 AutoPackSafe</span>
          <div className="flex gap-4">
            <a href="#" style={{color:'var(--fg-muted)'}}>Términos</a>
            <a href="#" style={{color:'var(--fg-muted)'}}>Privacidad</a>
            <a href="#" style={{color:'var(--fg-muted)'}}>Soporte</a>
          </div>
        </div>
      </div>

      {/* Right artwork */}
      <div className="r-auth-artwork" style={{
        background: 'linear-gradient(135deg, #1e3a8a 0%, #1e40af 50%, #4f46e5 100%)',
        position: 'relative', overflow: 'hidden',
        display: 'flex', flexDirection: 'column', padding: 64,
        color: 'white',
      }}>
        <div style={{
          position: 'absolute', inset: 0,
          backgroundImage: `linear-gradient(rgba(255,255,255,0.06) 1px, transparent 1px),
            linear-gradient(90deg, rgba(255,255,255,0.06) 1px, transparent 1px)`,
          backgroundSize: '48px 48px',
          maskImage: 'radial-gradient(ellipse at 70% 30%, black 0%, transparent 70%)',
        }}/>
        <div style={{
          position: 'absolute', top: -150, right: -150,
          width: 500, height: 500, borderRadius: '50%',
          background: 'radial-gradient(circle, rgba(165,180,252,0.25) 0%, transparent 70%)',
        }}/>

        <div style={{ marginTop: 'auto', position: 'relative', maxWidth: 480 }}>
          <Icon name="quote" size={36} color="rgba(255,255,255,0.4)" style={{ marginBottom: 24 }}/>
          <p style={{ fontSize: 22, lineHeight: 1.4, fontWeight: 500, letterSpacing: '-0.015em', margin: 0, marginBottom: 24 }}>
            "Bajamos el costo por envío 84% y migramos en una tarde.
            La velocidad de las reclamaciones cambió completamente nuestra operación."
          </p>
          <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
            <div style={{
              width: 40, height: 40, borderRadius: '50%',
              background: 'rgba(255,255,255,0.20)',
              display: 'flex', alignItems: 'center', justifyContent: 'center',
              fontSize: 14, fontWeight: 600,
            }}>MV</div>
            <div>
              <div style={{ fontWeight: 600, fontSize: 14 }}>Marisol Vega</div>
              <div className="text-mono" style={{ fontSize: 12, opacity: 0.7 }}>CTO · EnvíosMX</div>
            </div>
          </div>
        </div>

        <div style={{ position: 'absolute', top: 64, right: 64, display: 'flex', gap: 12, alignItems: 'center' }}>
          <span className="pill text-mono" style={{
            background: 'rgba(255,255,255,0.10)', color: 'white',
            border: '1px solid rgba(255,255,255,0.20)', fontSize: 11,
          }}>
            <span style={{ width: 6, height: 6, borderRadius: '50%', background: '#86efac' }}/>
            API operativa
          </span>
        </div>
      </div>
    </div>
  );
}

export default function LoginPage() {
  const [mode, setMode] = useState('login'); // login | register | recover
  const [email, setEmail] = useState('krathos@gmail.com');
  const [password, setPassword] = useState('123456789');
  const [showPwd, setShowPwd] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [recoverSent, setRecoverSent] = useState(false);

  const submit = (e) => {
    e.preventDefault();
    setError(null); setLoading(true);
    setTimeout(() => {
      setLoading(false);
      if (mode === 'recover') {
        setRecoverSent(true);
        return;
      }
      // mock success — match the API response shape
      localStorage.setItem('aps_session', JSON.stringify({
        client: {
          first_name: 'Julio', last_name: 'Arroyo',
          email: email, phone: '3310121981', company_name: 'Planeta Envios',
        },
        token: '75VeNxiqzUVERKfjK8wSPKaZmYBLFaT04kJU62YV883d3589',
      }));
      window.location.hash = '#/dashboard';
    }, 700);
  };

  if (mode === 'recover') {
    return (
      <AuthShell
        eyebrow="Recuperar acceso"
        title={recoverSent ? 'Revisa tu correo.' : '¿Olvidaste tu contraseña?'}
        subtitle={recoverSent ? `Enviamos un enlace de recuperación a ${email}. Revisa tu bandeja en los próximos minutos.` : 'Te enviamos un enlace para crear una nueva contraseña.'}
      >
        {!recoverSent ? (
          <form onSubmit={submit} style={{ display: 'flex', flexDirection: 'column', gap: 16 }}>
            <div>
              <label className="label">Correo electrónico</label>
              <input type="email" className="input" required
                     value={email} onChange={e=>setEmail(e.target.value)}
                     placeholder="tu@empresa.mx"/>
            </div>
            <button type="submit" className="btn btn-primary btn-lg" disabled={loading}>
              {loading ? 'Enviando…' : 'Enviar enlace'} {!loading && <Icon name="arrow" size={16}/>}
            </button>
            <button type="button" onClick={() => setMode('login')} className="btn btn-ghost btn-sm" style={{ marginTop: 8 }}>
              ← Volver al login
            </button>
          </form>
        ) : (
          <div style={{ display: 'flex', flexDirection: 'column', gap: 16 }}>
            <div className="card" style={{ padding: 16, background: 'var(--success-soft)', borderColor: 'rgba(21,128,61,0.20)', display: 'flex', gap: 12, alignItems: 'flex-start' }}>
              <Icon name="check" size={18} color="var(--success)" style={{ marginTop: 2 }}/>
              <div style={{ fontSize: 13, color: 'var(--success)', lineHeight: 1.5 }}>
                <strong>Correo enviado.</strong> El enlace expira en 30 minutos.
              </div>
            </div>
            <button onClick={() => { setMode('login'); setRecoverSent(false); }} className="btn btn-secondary btn-lg">
              Volver al login
            </button>
          </div>
        )}
      </AuthShell>
    );
  }

  return (
    <AuthShell
      eyebrow={mode === 'login' ? 'Iniciar sesión' : 'Crear cuenta'}
      title={mode === 'login' ? 'Bienvenido de vuelta.' : 'Empieza a proteger tus envíos.'}
      subtitle={mode === 'login' ? 'Entra a tu dashboard para ver tus envíos protegidos y métricas.' : 'Crea tu cuenta gratis. Sin tarjeta de crédito.'}
    >
      <form onSubmit={submit} style={{ display: 'flex', flexDirection: 'column', gap: 14 }}>
        {mode === 'register' && (
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 12 }}>
            <div>
              <label className="label">Nombre</label>
              <input type="text" className="input" required placeholder="Julio"/>
            </div>
            <div>
              <label className="label">Apellido</label>
              <input type="text" className="input" required placeholder="Arroyo"/>
            </div>
          </div>
        )}
        {mode === 'register' && (
          <div>
            <label className="label">Empresa</label>
            <input type="text" className="input" required placeholder="Planeta Envios"/>
          </div>
        )}
        <div>
          <label className="label">Correo electrónico</label>
          <input type="email" className="input" required
                 value={email} onChange={e=>setEmail(e.target.value)}
                 placeholder="tu@empresa.mx" autoComplete="email"/>
        </div>
        <div>
          <div className="flex items-center justify-between" style={{ marginBottom: 6 }}>
            <label className="label" style={{ marginBottom: 0 }}>Contraseña</label>
            {mode === 'login' && (
              <button type="button" onClick={() => setMode('recover')} style={{
                background: 'transparent', border: 'none', padding: 0,
                fontSize: 12, color: 'var(--brand)', fontWeight: 500, cursor: 'pointer',
              }}>
                ¿Olvidaste tu contraseña?
              </button>
            )}
          </div>
          <div style={{ position: 'relative' }}>
            <input type={showPwd ? 'text' : 'password'} className="input" required
                   value={password} onChange={e=>setPassword(e.target.value)}
                   placeholder="••••••••••" autoComplete={mode==='login'?'current-password':'new-password'}
                   style={{ paddingRight: 44 }}/>
            <button type="button" onClick={() => setShowPwd(!showPwd)} style={{
              position: 'absolute', right: 12, top: '50%', transform: 'translateY(-50%)',
              background: 'transparent', border: 'none', color: 'var(--fg-muted)',
              padding: 4, cursor: 'pointer',
            }}>
              <Icon name={showPwd ? 'eye-off' : 'eye'} size={16}/>
            </button>
          </div>
        </div>
        {mode === 'register' && (
          <label className="flex items-center gap-2" style={{ fontSize: 13, color: 'var(--fg-secondary)', marginTop: 4 }}>
            <input type="checkbox" required style={{ accentColor: 'var(--brand)' }}/>
            Acepto los <a href="#" style={{color:'var(--brand)'}}>Términos</a> y la <a href="#" style={{color:'var(--brand)'}}>Privacidad</a>.
          </label>
        )}
        {error && (
          <div style={{ padding: 12, borderRadius: 8, background: 'var(--danger-soft)', color: 'var(--danger)', fontSize: 13 }}>
            {error}
          </div>
        )}
        <button type="submit" className="btn btn-primary btn-lg" disabled={loading} style={{ marginTop: 8 }}>
          {loading ? (mode === 'login' ? 'Verificando…' : 'Creando cuenta…') : (mode === 'login' ? 'Entrar' : 'Crear cuenta')}
          {!loading && <Icon name="arrow" size={16}/>}
        </button>
      </form>

      <div style={{ display: 'flex', alignItems: 'center', gap: 12, margin: '24px 0', color: 'var(--fg-faint)', fontSize: 12 }}>
        <div style={{ flex: 1, height: 1, background: 'var(--border)' }}/>
        <span className="text-mono" style={{ textTransform: 'uppercase', letterSpacing: '0.08em' }}>O</span>
        <div style={{ flex: 1, height: 1, background: 'var(--border)' }}/>
      </div>

      <button type="button" onClick={submit} className="btn btn-secondary btn-lg" style={{ width: '100%' }}>
        <GoogleIcon size={16}/> Continuar con Google
      </button>

      <div style={{ marginTop: 32, fontSize: 14, textAlign: 'center', color: 'var(--fg-secondary)' }}>
        {mode === 'login' ? (
          <>¿No tienes cuenta? <button onClick={() => setMode('register')} style={{ background:'none', border:'none', color:'var(--brand)', fontWeight:600, cursor:'pointer', padding:0, fontSize:14 }}>Crear cuenta</button></>
        ) : (
          <>¿Ya tienes cuenta? <button onClick={() => setMode('login')} style={{ background:'none', border:'none', color:'var(--brand)', fontWeight:600, cursor:'pointer', padding:0, fontSize:14 }}>Iniciar sesión</button></>
        )}
      </div>
    </AuthShell>
  );
}
